import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { Box, Grid, Button } from '@material-ui/core';
import { useFormPagamentoComissaoValidation } from './form-comissao-pagamento-validation';
import { CircularLoading } from 'views/components/utils/circular-loading/circular-loading';
import {
    TextFieldSaurus,

} from 'views/components/controles/inputs';
import {
    DefaultFormProps,
    DefaultFormRefs,
} from 'views/components/form/utils/form-default-props';
import { useThemeQueries, makeUtilClasses } from 'views';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { picker } from 'utils/picker';
import { KeyValueModel } from 'model';
import { SelectSaurus } from 'views/components/controles/selects/select-saurus/select-saurus';
import { ComissaoPostModel } from 'model/api/gestao/comissao/comissao-post-model';

interface FormComissaoPagamentoProps extends DefaultFormProps<ComissaoPostModel> {
    aberto: boolean;
}


export const FormComissaoPagamento = forwardRef<
    DefaultFormRefs<ComissaoPostModel>,
    FormComissaoPagamentoProps
>(
    (
        { loading, onSubmit, aberto, ...props }: FormComissaoPagamentoProps,
        ref,
    ) => {
        const { isMobile } = useThemeQueries();
        const utilClasses = makeUtilClasses();
        const refInputNome = useRef<HTMLInputElement>(null);
        const { FormPagamentoComissaoValidationYup } = useFormPagamentoComissaoValidation()
        const [modelForm, setModelForm] = useState<ComissaoPostModel>(new ComissaoPostModel())


        const {
            handleSubmit,
            control,
            formState: { errors },
            reset,
        } = useForm<ComissaoPostModel>({
            defaultValues: { ...modelForm },
            resolver: yupResolver(FormPagamentoComissaoValidationYup),
            criteriaMode: 'all',
            mode: 'onChange',
        });

        useImperativeHandle(ref, () => ({
            submitForm: () => {
                handleSubmit(submitEnviar)();
            },
            resetForm: () => {
                reset();
                if (!isMobile) refInputNome.current?.focus();
            },
            fillForm: (model: ComissaoPostModel) => {
                setModelForm({ ...model })
                reset({ ...model });
                if (!isMobile) refInputNome.current?.focus();
            },
        }));

        const carregando = loading

        const submitEnviar = (values: ComissaoPostModel) => {
            const ComissaoPostModel = picker<ComissaoPostModel>(values, modelForm)
            ComissaoPostModel.faturasComissoes = Object.values(ComissaoPostModel.faturasComissoes).map(value => value)
            const date = new Date();

            ComissaoPostModel.dataPagamento = [date.getFullYear(), (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1), (date.getDate() > 9 ? '' : '0') + date.getDate()].join('-')


            onSubmit(ComissaoPostModel, modelForm);
        };

        return (
            <>
                <Box my={2}>
                    <div className={utilClasses.formContainer}>
                        {carregando && props.showLoading && (
                            <CircularLoading tipo="FULLSIZED" />
                        )}

                        <form
                            onSubmit={handleSubmit(submitEnviar)}
                            className={loading ? utilClasses.controlLoading : ''}
                        >
                            <Grid container spacing={2}>
                                <Grid item md={6} xs={12}>
                                    <Controller
                                        name="observacao"
                                        control={control}
                                        render={({ field }) => (
                                            <TextFieldSaurus
                                                disabled={loading}
                                                allowSubmit={false}
                                                id="observacao"
                                                label="Observações"
                                                fullWidth
                                                autoComplete={'off'}
                                                helperText={
                                                    errors.observacao
                                                        ? errors.observacao.message
                                                        : undefined
                                                }
                                                error={Boolean(errors.observacao && errors.observacao.message)}
                                                {...field}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <Controller
                                        name="contabilizaRelatorios"
                                        control={control}
                                        render={({ field }) => (
                                            <SelectSaurus
                                                disabled={loading}
                                                conteudo={[
                                                    new KeyValueModel(true, 'Sim'),
                                                    new KeyValueModel(false, 'Não')
                                                ]}
                                                allowSubmit={false}
                                                label="Contabiliza Relatórios"
                                                fullWidth
                                                autoComplete={'off'}
                                                helperText={
                                                    errors.contabilizaRelatorios
                                                        ? errors.contabilizaRelatorios.message
                                                        : undefined
                                                }
                                                error={Boolean(errors.contabilizaRelatorios && errors.contabilizaRelatorios.message)}
                                                {...field}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <Controller
                                        name="valorTotal"
                                        control={control}
                                        render={({ field }) => (
                                            <TextFieldSaurus
                                                disabled={loading}
                                                allowSubmit={false}
                                                id="valorTotal"
                                                label="Valor Total da Comissão"
                                                tipo='DECIMAL'
                                                showStartAdornment
                                                manterMascara
                                                positivo
                                                fullWidth
                                                autoComplete={'off'}
                                                helperText={
                                                    errors.valorTotal
                                                        ? errors.valorTotal.message
                                                        : undefined
                                                }
                                                error={Boolean(errors.valorTotal && errors.valorTotal.message)}
                                                {...field}
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                            <Button style={{ display: 'none' }} type="submit"></Button>
                        </form>
                    </div>
                </Box>
            </>
        );
    },
);